export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-die-one-b7880cf5cceeb57386efad3e299edd3c.svg";